













import { namespace } from 'vuex-class';
import { Component, Prop, Vue } from 'vue-property-decorator';

import router from '@/main/router';

import Footer from '@/shared/components/Layout/Footer.vue';
import UpsellPaymentModal from './UpsellPaymentModal.vue';

import { IUpsell } from '@/interfaces/Upsell';
import { IOrder } from '@/interfaces/Order';
import { EInteractEventTrackerAction } from '@/app/features/InteractEventTracker/enums/EInteractEventTracker';

import { EErrorExhibition } from '@/helpers/enums';
import { pushRefusalUpsellClickToDatalayer } from '@/helpers/dataLayer';
import { sendInteractEvent } from '@/helpers/events';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Footer,
    UpsellPaymentModal,
  }
})
export default class Upsell extends Vue {
  @CheckoutModule.Action
  private getRefusalUpsell: Function;

  @CheckoutModule.Mutation
  private showUpsellModal: Function;

  @CheckoutModule.Mutation
  private closeUpsellModal: Function;

  @CheckoutModule.State('modalUpsell')
  private modalUpsellVisibility: boolean;

  @Prop()
  private upsell: IUpsell;

  @Prop()
  private order: IOrder;

  @Prop({ default: '#' })
  private refusalUrl: string;

  private close() {
    this.closeUpsellModal();
  }

  private publishClick() {
    window.location.replace(this.upsell.target_content_url);
  }

  private confirmClick() {
    this.showUpsellModal();
  }

  private async refuseClick() {
    sendInteractEvent({ action: EInteractEventTrackerAction.UPSELL_OFFER_DENIED });

    pushRefusalUpsellClickToDatalayer(
      this.order,
      this.upsell,
      this.upsell.url_for_refusal_action || this.upsell.target_content_url,
    );

    if (this.upsell.refusal_upsell) {
      const refusalUpsell = await this.getRefusalUpsell(this.upsell.refusal_upsell.id);
      if (!refusalUpsell) {
        this.goOut();
      }
    } else {
      this.goOut();
    }
  }

  private goOut() {
    const { url_for_refusal_action, target_content_url } = this.upsell;
    const url = url_for_refusal_action || target_content_url;

    window.open(url, '_blank', 'noopener');
  }

  private enableClassBehavior(): void {
    const $upsell = document.querySelector('.upsell');

    function bindAction(selector: string, callback: Function) {
      $upsell!.addEventListener('click', event => {
        const $target = event.target as HTMLElement;
        if ($target.closest(selector)) {
          event.preventDefault();
          callback();
        }
      });
    }

    bindAction('.trigger-publicacoes', this.publishClick);
    bindAction('.trigger-recusa', this.refuseClick);
    bindAction('.trigger-confirma, .trigger-modal-upsell', this.confirmClick);
  }

  private beforeDestroy () {
    this.$root.$off('openUpsellModal');
  }

  private mounted() {
    this.enableClassBehavior();
    this.$root.$on('openUpsellModal', (value: any) => {
      if (value) {
        this.showUpsellModal();
      }
    });

    sendInteractEvent({ action: EInteractEventTrackerAction.UPSELL_OFFER });
  }
}
